export default "__VITE_ASSET__C99TY3pI__"